var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTool5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3054_8129)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.0023,
    cy: 11.6447,
    r: 7.50038,
    fill: "#B9D6DE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.0023,
    cy: 11.6447,
    r: 7.50038,
    stroke: "#8CBBC8",
    strokeWidth: 1.38896
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0029 1.92212V4.14445",
    stroke: "#8CBBC8",
    strokeWidth: 1.38896,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.61426 1.92212H11.3922",
    stroke: "#8CBBC8",
    strokeWidth: 1.38896,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.92198,
    cy: 1.92198,
    r: 1.92198,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 7.31934 11.5613)",
    fill: "#62A1B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.603 7.78725C12.9426 7.49312 13.4518 7.51137 13.7695 7.82905C14.0872 8.14673 14.1054 8.65588 13.8113 8.99549L10.6866 12.6033L8.99526 10.912L12.603 7.78725Z",
    fill: "#62A1B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3054_8129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.501953)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTool5);
export default __webpack_public_path__ + "static/media/tool_5.37dd691b169591a83a4b8f1bad736e9a.svg";
export { ForwardRef as ReactComponent };